import { useCustomSWR } from 'utils/hooks/fetchers'

export const useGreetings = (props) => {
  const { data, ...rest } = useCustomSWR(
    `/systemSettings/specificKey?key=greeting`
  )
  return {
    data: data?.[0]?.value,
    ...rest,
  }
}
